import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { createEntityAdapter } from '../../../helpers/create-entity-adapter';
import { Business } from '../../../interfaces/business.interface';
import { GetBusinessesResponse } from '../interfaces/get-business';

export interface BusinessState {
  businesses: {
    ids: string[];
    entities: Record<string, Business>;
  };
  business: Business | null;
  page: number;
  size: number;
  total: number;
  noMore: boolean;
  errorCode: number | null;
}

const initialState: BusinessState = {
  businesses: {
    ids: [],
    entities: {},
  },
  business: null,
  page: 1,
  size: 100,
  total: 0,
  noMore: false,
  errorCode: null,
};

const businessAdapter = createEntityAdapter<Business>((business: Business) => business.id);

const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getBusinessesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getBusinessesSuccessApiAction: (
      state,
      action: PayloadAction<GetBusinessesResponse>
    ) => {
      businessAdapter.addMany(action.payload.businesses, state.businesses);
      state.total = action.payload.pagination.total_elements;
      state.page = action.payload.pagination.page;
      state.size = action.payload.pagination.size;
      state.noMore = action.payload.businesses.length < state.size;
    },
    getBusinessesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postBusinessInitApiAction: (state) => {
      state.errorCode = null;
    },
    postBusinessSuccessApiAction: () => { },
    postBusinessFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putBusinessInitApiAction: (state) => {
      state.errorCode = null;
    },
    putBusinessSuccessApiAction: () => { },
    putBusinessFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    deleteBusinessInitApiAction: () => { },
    deleteBusinessSuccessApiAction: () => { },
    deleteBusinessFailuireApiAction: () => { },
    setBusinessAction: (state, action: PayloadAction<Business | null>) => {
      state.business = action.payload;
    },
    increasePageAction: (state) => {
      state.page += 1;
    },
    resetPageAction: (state) => {
      state.page = 1;
    },
    businessClearAction: (state) => {
      state.business = null;
      state.errorCode = null;
    },
    postAreaInitApiAction: (state) => {
      state.errorCode = null;
    },
    postAreaSuccessApiAction: () => { },
    postAreaFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putAreaInitApiAction: (state) => {
      state.errorCode = null;
    },
    putAreaSuccessApiAction: () => { },
    putAreaFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    deleteAreaInitApiAction: (state) => {
      state.errorCode = null;
    },
    deleteAreaSuccessApiAction: () => { },
    deleteAreaFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
  },
});

export const {
  getBusinessesInitApiAction,
  getBusinessesSuccessApiAction,
  getBusinessesFailureApiAction,
  postBusinessInitApiAction,
  postBusinessSuccessApiAction,
  postBusinessFailuireApiAction,
  putBusinessInitApiAction,
  putBusinessSuccessApiAction,
  putBusinessFailuireApiAction,
  deleteBusinessInitApiAction,
  deleteBusinessSuccessApiAction,
  deleteBusinessFailuireApiAction,
  setBusinessAction,
  increasePageAction,
  resetPageAction,
  businessClearAction,
  postAreaInitApiAction,
  postAreaSuccessApiAction,
  postAreaFailureApiAction,
  putAreaInitApiAction,
  putAreaSuccessApiAction,
  putAreaFailureApiAction,
  deleteAreaInitApiAction,
  deleteAreaSuccessApiAction,
  deleteAreaFailureApiAction,
} = businessSlice.actions;

export default businessSlice.reducer;
